import { formatDistanceToNow, format } from 'date-fns';

export const formatTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return format(date, 'MMM d, yyyy h:mm a');
};

export const formatRelativeTime = (timestamp: number): string => {
    return formatDistanceToNow(timestamp, { addSuffix: true });
}; 